import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async (params, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.personal.getStatistics, { ...params }, options);
    if (error) return { error, status };
    return content || {
        orgCount: 0, // 个人创建的组织机构数
    };
};
